import Nullstack from 'nullstack';
export default function IconSkateboard({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-skateboard",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1"
  }), " ");
}